import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  /** Kicker opcional sobre el título (mono micro). */
  kicker?: string;
}

export function PageHeader({ title, description, actions, kicker }: PageHeaderProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {kicker ? (
          <p className="mb-2 font-mono text-[10px] font-medium uppercase tracking-[0.22em] text-muted-foreground">
            {kicker}
          </p>
        ) : null}
        <h1 className="font-display text-[2rem] font-medium leading-[1.1] tracking-display-tight text-foreground">
          {title}
        </h1>
        {description ? (
          <p className="mt-2 max-w-2xl text-[14px] leading-relaxed text-muted-foreground">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
